module.exports = __webpack_public_path__ + "img/shortTip.16c56444.png";